module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/WebsiteDesignPdpIntro_hero@2x-b268054f97233b2643a5c023b155fe92.jpg";